export const address = {
  address: '123 Test St',
  address2: undefined,
  attention: 'Attn: Mailroom',
  city: 'Austin',
  state: 'TX',
  postal: '78721',
  country: 'US',
  fname: 'Oura',
  lname: 'Test',
};
